<template>
  <div class="filters-container">

    <h3 class="filters-title">
      Фильтры
    </h3>


    <!-- =====================================================
         CONSULTANTS
    ====================================================== -->

    <div class="filter-group">

      <p class="filter-label">
        Консультанты
      </p>

      <div class="filter-options-row">

        <label
          class="filter-pill"
          :class="{
            active:
              selectedConsultant === 'all'
          }"
        >
          <input
            type="radio"
            name="consultant"
            value="all"
            v-model="selectedConsultant"
          />

          <span>
            Все
          </span>
        </label>


        <label
          class="filter-pill"
          :class="{
            active:
              selectedConsultant ===
              'consultants-only'
          }"
        >
          <input
            type="radio"
            name="consultant"
            value="consultants-only"
            v-model="selectedConsultant"
          />

          <span>
            Консультанты
          </span>
        </label>

      </div>

    </div>


    <!-- =====================================================
         REMOTE
    ====================================================== -->

    <div class="filter-group">

      <p class="filter-label">
        Удалёнка
      </p>

      <div class="filter-options-row">

        <label
          class="filter-pill"
          :class="{
            active:
              selectedRemote === 'all'
          }"
        >
          <input
            type="radio"
            name="remote"
            value="all"
            v-model="selectedRemote"
          />

          <span>
            Все
          </span>
        </label>


        <label
          class="filter-pill"
          :class="{
            active:
              selectedRemote ===
              'remote-only'
          }"
        >
          <input
            type="radio"
            name="remote"
            value="remote-only"
            v-model="selectedRemote"
          />

          <span>
            Ищут удалёнку
          </span>
        </label>

      </div>

    </div>


    <!-- =====================================================
         DATE / ACTIVITY
    ====================================================== -->

    <div class="filter-group">

      <p class="filter-label">
        Показать
      </p>

      <div class="filter-options-column">

        <!-- ALL -->

        <label
          class="filter-pill filter-pill-wide"
          :class="{
            active:
              selectedDate === 'all'
          }"
        >
          <input
            type="radio"
            name="active"
            value="all"
            v-model="selectedDate"
          />

          <span>
            Все
          </span>
        </label>


        <!-- LAST 24 HOURS -->

        <label
          class="filter-pill filter-pill-wide"
          :class="{
            active:
              selectedDate === '24h'
              && isPremiumEnabled,

            'premium-disabled':
              !isPremiumEnabled
          }"
        >
          <input
            type="radio"
            name="active"
            value="24h"
            v-model="selectedDate"
            :disabled="!isPremiumEnabled"
          />

          <span class="premium-filter-content">

            <span>
              Последние 24 часа
            </span>

            <span
              v-if="!isPremiumEnabled"
              class="premium-lock"
              aria-hidden="true"
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
              >
                <rect
                  x="6"
                  y="10"
                  width="12"
                  height="9"
                  rx="2"
                  stroke="currentColor"
                  stroke-width="1.7"
                />

                <path
                  d="
                    M8.5 10
                    V7.5
                    C8.5 5.57
                    10.07 4
                    12 4
                    C13.93 4
                    15.5 5.57
                    15.5 7.5
                    V10
                  "
                  stroke="currentColor"
                  stroke-width="1.7"
                  stroke-linecap="round"
                />
              </svg>
            </span>

          </span>
        </label>


        <!-- LAST 7 DAYS -->

        <label
          class="filter-pill filter-pill-wide"
          :class="{
            active:
              selectedDate === '7d'
              && isPremiumEnabled,

            'premium-disabled':
              !isPremiumEnabled
          }"
        >
          <input
            type="radio"
            name="active"
            value="7d"
            v-model="selectedDate"
            :disabled="!isPremiumEnabled"
          />

          <span class="premium-filter-content">

            <span>
              Последние 7 дней
            </span>

            <span
              v-if="!isPremiumEnabled"
              class="premium-lock"
              aria-hidden="true"
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
              >
                <rect
                  x="6"
                  y="10"
                  width="12"
                  height="9"
                  rx="2"
                  stroke="currentColor"
                  stroke-width="1.7"
                />

                <path
                  d="
                    M8.5 10
                    V7.5
                    C8.5 5.57
                    10.07 4
                    12 4
                    C13.93 4
                    15.5 5.57
                    15.5 7.5
                    V10
                  "
                  stroke="currentColor"
                  stroke-width="1.7"
                  stroke-linecap="round"
                />
              </svg>
            </span>

          </span>
        </label>

      </div>


      <!-- PREMIUM INFO -->

      <div
        v-if="!isPremiumEnabled"
        class="premium-hint"
        role="button"
        tabindex="0"
        @click="handlePremiumClick"
        @keydown.enter="handlePremiumClick"
        @keydown.space.prevent="handlePremiumClick"
      >
        <span class="premium-hint-icon">
          <svg
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="
                M12 3
                L14.7 8.3
                L20.5 9.1
                L16.3 13.2
                L17.3 19
                L12 16.3
                L6.7 19
                L7.7 13.2
                L3.5 9.1
                L9.3 8.3
                L12 3Z
              "
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linejoin="round"
            />
          </svg>
        </span>

        <span>
          Фильтры по активности доступны
          только по подписке Premium
        </span>
      </div>

    </div>

  </div>
</template>


<script setup>

import {
  ref,
  watch
} from "vue";


const props = defineProps({

  initialConsultant: {
    type: String,
    default: "all"
  },

  initialRemote: {
    type: String,
    default: "all"
  },

  initialDate: {
    type: String,
    default: "all"
  },

  isPremiumEnabled: {
    type: Boolean,
    default: false
  }

});


const emit = defineEmits([
  "filtersChanged",
  "premiumClick"
]);

function handlePremiumClick() {
  if (props.isPremiumEnabled) {
    return;
  }

  emit("premiumClick");
}

const selectedConsultant =
  ref(
    props.initialConsultant
  );

const selectedRemote =
  ref(
    props.initialRemote
  );

const selectedDate =
  ref(
    props.initialDate
  );


/* =========================================================
   INITIAL VALUES
========================================================= */

watch(
  () =>
    props.initialConsultant,

  value => {

    selectedConsultant.value =
      value;

  }
);


watch(
  () =>
    props.initialRemote,

  value => {

    selectedRemote.value =
      value;

  }
);


watch(
  () =>
    props.initialDate,

  value => {

    selectedDate.value =
      value;

  }
);


/* =========================================================
   PREMIUM STATUS
========================================================= */

watch(
  () =>
    props.isPremiumEnabled,

  (
    isPremium,
    previousValue
  ) => {

    /*
     * Если Premium реально был включён,
     * а затем отключился,
     * сбрасываем premium date filter.
     *
     * Не делаем reset при первом false,
     * потому что статус приходит
     * асинхронно из FeedHeader.
     */

    if (
      previousValue === true
      && isPremium === false
      && (
        selectedDate.value === "24h"
        || selectedDate.value === "7d"
      )
    ) {

      selectedDate.value =
        "all";

    }

  }
);


/* =========================================================
   EMIT FILTERS
========================================================= */

watch(
  [
    selectedConsultant,
    selectedRemote,
    selectedDate
  ],

  () => {

    emit(
      "filtersChanged",
      {

        consultant:
          selectedConsultant.value,

        remote:
          selectedRemote.value,

        date:
          selectedDate.value

      }
    );

  }
);


defineExpose({
  selectedConsultant,
  selectedRemote,
  selectedDate
});

</script>


<style scoped>

/* =========================================================
   ORIGINAL LAYOUT
   Размеры здесь НЕ меняем
========================================================= */

.filters-container {
  width: 220px;

  padding: 24px;

  font-family:
    "Eastman-Regular",
    sans-serif;

  background:
    #ffffff;

  border:
    1px solid
    rgba(25, 40, 60, 0.07);

  border-radius: 16px;

  box-shadow:
    0 14px 34px
    rgba(15, 23, 42, 0.04);
}


.filters-title {
  margin:
    10px
    0
    24px;

  color:
    #2f343a;

  font-family:
    "Eastman-Bold",
    sans-serif;

  font-size: 14px;

  letter-spacing:
    -0.2px;
}


.filter-group {
  margin-bottom: 24px;
}


.filter-group:last-child {
  margin-bottom: 0;
}


.filter-label {
  margin:
    0
    0
    12px;

  color:
    #777e87;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size: 10px;

  letter-spacing:
    0.15px;

  text-transform:
    uppercase;
}


.filter-options-row {
  display: flex;
  flex-wrap: wrap;

  gap: 7px;
}


.filter-options-column {
  display: flex;
  flex-direction: column;

  gap: 7px;
}


.filter-pill {
  position: relative;

  min-height: 30px;

  display: inline-flex;
  align-items: center;
  justify-content: center;

  box-sizing: border-box;

  padding:
    0
    11px;

  color:
    #66707c;

  background:
    #f4f6f8;

  border:
    1px solid
    rgba(35, 55, 80, 0.055);

  border-radius: 10px;

  font-family:
    "Eastman-Medium",
    sans-serif;

  font-size: 10px;

  cursor: pointer;

  user-select: none;

  transition:
    color 0.18s ease,
    background-color 0.18s ease,
    border-color 0.18s ease,
    box-shadow 0.18s ease,
    transform 0.18s ease,
    opacity 0.18s ease;
}


.filter-pill input {
  position: absolute;

  opacity: 0;

  pointer-events: none;
}


.filter-pill:hover {
  color:
    #465466;

  background:
    #eef2f6;

  transform:
    translateY(-1px);
}


.filter-pill.active {
  color:
    #356da9;

  background:
    rgba(55, 127, 228, 0.08);

  border-color:
    rgba(55, 127, 228, 0.12);

  box-shadow:
    inset
    0
    0
    0
    1px
    rgba(55, 127, 228, 0.025);
}


.filter-pill-wide {
  width: 100%;

  justify-content:
    flex-start;

  padding-left: 12px;
}


/* =========================================================
   PREMIUM CONTENT
========================================================= */

.premium-filter-content {
  width: 100%;

  display: flex;

  align-items: center;

  justify-content:
    space-between;

  gap: 8px;
}


/* =========================================================
   DISABLED PREMIUM FILTER
========================================================= */

.filter-pill.premium-disabled {
  color:
    #a6abb2;

  background:
    #f6f7f8;

  border-color:
    rgba(35, 55, 80, 0.04);

  cursor:
    not-allowed;

  opacity:
    0.72;

  transform:
    none;

  box-shadow:
    none;
}


.filter-pill.premium-disabled:hover {
  color:
    #a6abb2;

  background:
    #f6f7f8;

  border-color:
    rgba(35, 55, 80, 0.04);

  transform:
    none;

  box-shadow:
    none;
}


/* =========================================================
   LOCK
========================================================= */

.premium-lock {
  flex-shrink: 0;

  display:
    inline-flex;

  align-items:
    center;

  justify-content:
    center;

  color:
    #a3a8ae;
}


.premium-lock svg {
  width: 12px;
  height: 12px;

  display: block;
}


/* =========================================================
   PREMIUM HINT
   Только увеличивает высоту блока
========================================================= */

.premium-hint {
  display: flex;

  align-items:
    flex-start;

  gap: 7px;

  margin-top:
    10px;

  padding:
    9px
    10px;

  color:
    #858b93;

  background:
    rgba(
      109,
      88,
      190,
      0.045
    );

  border:
    1px solid
    rgba(
      109,
      88,
      190,
      0.07
    );

  border-radius:
    10px;

  font-family:
    "Eastman-Regular",
    sans-serif;

  font-size:
    9px;

  line-height:
    1.45;
}


.premium-hint-icon {
  flex-shrink:
    0;

  display:
    inline-flex;

  align-items:
    center;

  justify-content:
    center;

  margin-top:
    1px;

  color:
    #8d70c3;
}


.premium-hint-icon svg {
  width:
    13px;

  height:
    13px;

  display:
    block;
}


/* =========================================================
   DARK
========================================================= */

html[data-theme="dark"]
.filters-container {
  background:
    linear-gradient(
      145deg,
      #22242a,
      #1d1f24
    );

  border-color:
    rgba(255, 255, 255, 0.065);

  box-shadow:
    0
    16px
    40px
    rgba(0, 0, 0, 0.18);
}


html[data-theme="dark"]
.filters-title {
  color:
    #f0f1f3;
}


html[data-theme="dark"]
.filter-label {
  color:
    #737982;
}


html[data-theme="dark"]
.filter-pill {
  color:
    #969da7;

  background:
    rgba(255, 255, 255, 0.035);

  border-color:
    rgba(255, 255, 255, 0.05);
}


html[data-theme="dark"]
.filter-pill:hover {
  color:
    #c7ccd3;

  background:
    rgba(255, 255, 255, 0.055);
}


html[data-theme="dark"]
.filter-pill.active {
  color:
    #b8d1f5;

  background:
    rgba(91, 158, 255, 0.09);

  border-color:
    rgba(91, 158, 255, 0.12);

  box-shadow:
    inset
    0
    0
    0
    1px
    rgba(91, 158, 255, 0.02);
}


/* =========================================================
   DARK PREMIUM DISABLED
========================================================= */

html[data-theme="dark"]
.filter-pill.premium-disabled {
  color:
    #626872;

  background:
    rgba(
      255,
      255,
      255,
      0.018
    );

  border-color:
    rgba(
      255,
      255,
      255,
      0.028
    );

  opacity:
    0.72;

  transform:
    none;

  box-shadow:
    none;
}


html[data-theme="dark"]
.filter-pill.premium-disabled:hover {
  color:
    #626872;

  background:
    rgba(
      255,
      255,
      255,
      0.018
    );

  border-color:
    rgba(
      255,
      255,
      255,
      0.028
    );

  transform:
    none;
}


html[data-theme="dark"]
.premium-lock {
  color:
    #686e76;
}


/* =========================================================
   DARK PREMIUM HINT
========================================================= */

html[data-theme="dark"]
.premium-hint {
  color:
    #777e87;

  background:
    rgba(
      130,
      101,
      205,
      0.045
    );

  border-color:
    rgba(
      145,
      115,
      220,
      0.07
    );
}


html[data-theme="dark"]
.premium-hint-icon {
  color:
    #967bc8;
}

.premium-hint {
  cursor: pointer;

  transition:
    background-color 0.18s ease,
    border-color 0.18s ease,
    transform 0.18s ease,
    box-shadow 0.18s ease;
}

.premium-hint:hover {
  background:
    rgba(
      109,
      88,
      190,
      0.075
    );

  border-color:
    rgba(
      109,
      88,
      190,
      0.13
    );

  transform:
    translateY(-1px);

  box-shadow:
    0 5px 14px
    rgba(
      109,
      88,
      190,
      0.07
    );
}

.premium-hint:active {
  transform:
    translateY(0)
    scale(0.985);
}

.premium-hint:focus-visible {
  outline:
    2px solid
    rgba(109, 88, 190, 0.28);

  outline-offset: 2px;
}

</style>